module.exports = __webpack_public_path__ + "img/campus.64278a5f.svg";